import { debounce } from 'lodash'

export default {
  data() {
    return {
      isLookupProductsDisabled: false,
    }
  },

  methods: {
    lookupProducts: debounce(async function (index, event) {
      if (this.isLookupProductsDisabled || this.isDisabledScanBarcode || !event) {
        this.data[index].selectize.loading = false
        return
      }
      this.data[index].selectize.loading = true
      await this.$store.dispatch('getProducts', {
        page: 1,
        limit: 10,
        q: event,
        no_category: true,
        no_modifier: true,
        no_discount: true,
        no_tax: true,
      })
      this.setProductsAvailable()
      this.showFinish(this.$Progress)
      this.data[index].selectize.loading = false
    }, 500),
    handleSelectProduct(index, event) {
      const skuId = event.value
      this.data[index].sku_id = skuId
      this.data[index].image = this.productImage(skuId)
      this.data[index].queryProductName = event.text
      this.data[index].selectize.loading = false
      this.optionSkus = []
      this.onPickedSku(skuId)

      this.isLookupProductsDisabled = true
      setTimeout(() => {
        this.isLookupProductsDisabled = false
      }, 600)
    },
    handleInputBlurProduct(index, event) {
      const data = this.data[index]

      if (data.is_saving_product) {
        return
      }

      if (!data.sku_id && this.optionSkus.length === 0) {
        this.data[index].queryProductName = ''
      }
    },
    handleBlurProduct(index, event) {
      const data = this.data[index]

      if (data.is_saving_product) {
        return
      }

      if (!data.sku_id) {
        this.data[index].queryProductName = ''
      }
    },
    handleKeydownProduct(index, event) {
      if (this.data[index].sku_id) {
        event.preventDefault()
      }
    },
    handleKeyupProduct(index, event) {
      if (this.isLookupProductsDisabled) {
        return
      }

      if (event.key === 'Backspace' && this.data[index].sku_id) {
        this.data[index].queryProductName = ''
      }

      if (!this.data[index].queryProductName) {
        this.data[index].sku_id = ''
        this.data[index].selectize.loading = false
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/orderAutocompleteInventoryDoc.js